import Image, { ImageProps } from 'next/image';
import { resolveImageLoader } from '~/shared/utils/loaders/resolveImageLoader';

export const DynamicImageLoader = (props: ImageProps) => {
    const loader = resolveImageLoader(props.src);

    return <Image {...props} loader={loader} />;
};
